import { z } from 'zod';
import { flag, oneOf } from '../../navigation/searchParams';

/** How the call is entered (form or JSON) and whether the advanced fields show. */
export const outboundCallsSearch = z.object({
  mode: oneOf(['form', 'json']),
  advanced: flag,
});
